<template>
  <div class="main-content-container overflow-hidden">
    <div class="card bg-white border-0 rounded-3 mb-4">
      <div class="card-body p-4">
        <AccessRole />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import AccessRole from "@/components/Pages/Tree/AccessRole.vue";

export default defineComponent({
  name: "GeneralDashboard",
  components: {
    AccessRole,
  },
});
</script>
